module.exports = __webpack_public_path__ + "img/gb829.prt.a39ded28.jpg";